import { Box, Button, Tooltip } from "@mui/material";
import { useContext } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";

import { DemandWalkEditsContext } from "../../../contexts/demand_walk_edits";
import { useForceUserEditConclude } from "../../modals/force_user_edit_conclude/index";

export const EditModeToggle = () => {
  const { editMode, setEditMode, discardChanges, loading } = useContext(
    DemandWalkEditsContext
  );
  const { openForceUserEditModal } = useForceUserEditConclude();

  const handleEdit = () => setEditMode(true);
  const handleSave = () => openForceUserEditModal(1);

  if (!editMode) {
    return (
      <Tooltip title="Edit Forecast" arrow>
        <Box sx={{ display: "flex", alignItems: "center", p: "5px" }}>
          <Button
            variant="contained"
            size="small"
            onClick={handleEdit}
            disabled={loading}
            sx={{
              fontSize: "0.75rem",
              minHeight: "32px",
              minWidth: "32px",
              borderRadius: "50%",
              p: "5px",
            }}
          >
            <EditIcon fontSize="small" />
          </Button>
        </Box>
      </Tooltip>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, p: "5px" }}>
      <Tooltip title="Discard Changes" arrow>
        <Button
          variant="outlined"
          color="error"
          size="small"
          onClick={discardChanges}
          disabled={loading}
          sx={{
            fontSize: "0.75rem",
            minHeight: "32px",
            minWidth: "32px",
            borderRadius: "50%",
            p: "5px",
          }}
        >
          <DeleteIcon fontSize="small" />
        </Button>
      </Tooltip>
      <Tooltip title="Save Changes" arrow>
        <Button
          variant="contained"
          size="small"
          onClick={handleSave}
          disabled={loading}
          sx={{
            fontSize: "0.75rem",
            minHeight: "32px",
            minWidth: "32px",
            borderRadius: "50%",
            p: "5px",
          }}
        >
          <SaveIcon fontSize="small" />
        </Button>
      </Tooltip>
    </Box>
  );
};
